export default __webpack_public_path__ + "static/media/safeIcon.3cf43f84.svg";